import LoanAmountInput from './loan-amount-input';

export default LoanAmountInput;
